module.exports = __webpack_public_path__ + "img/Basic.9479a63d.jpg";